module.exports = __webpack_public_path__ + "static/media/con_spa_per_to_wor.0ec07d16.png";